export default angular.module("bootstrap.http", []).run(function ($http, $rootScope, promiseTracker) {
  $http.defaults.withCredentials = true;
  if (typeof $rootScope.promiseTracker == "undefined") $rootScope.promiseTracker = promiseTracker({ activationDelay: 500 });
}).name;
